import { Component, Inject } from '@angular/core';

// RxJS
import { Subject } from 'rxjs';

// Types
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-record-test-filename',
  templateUrl: './record-test-filename.component.html',
  styleUrl: './record-test-filename.component.less',
  standalone: false
})
export class RecordTestFilenameComponent {

  // Public
  public name?: string;

  // Private
  private alive = new Subject<void>();

  /**
   * Constructor
   */

  constructor(
    public dialogRef: MatDialogRef<RecordTestFilenameComponent>,
    @Inject(MAT_DIALOG_DATA) public data: {filename: string}
  ) { }

  /**
   * Component lifecycle
   */

  ngOnInit(): void {
    this.name = this.data.filename;
  }

  ngOnDestroy(): void {
    this.alive.next();
    this.alive.complete();
  }

  /**
   * Methods
   */

  close(): void {
    this.dialogRef.close();
  }

  record(): void {
    if (this.name?.length) {
      this.dialogRef.close({filename: this.name});
    }
  }

}
